<template>
  <div class="mc-download__list-item">
    <div class="mc-download__list-item-wrapper d-flex">
      <i class="mc-fa icon-fill_videorecord"></i>
      <div class="mc-download__list-item-text">
        <p
          :title="`${licensePlate} ${convertedChannel} - ${momentDMYH(
            convertUtcToLocalDate(startTime, deviceTimezone)
          )} - ${momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone))}`"
        >
          {{ licensePlate }} {{ convertedChannel }} -
          {{ momentDMYH(convertUtcToLocalDate(startTime, deviceTimezone)) }}
          -
          {{ momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone)) }}
        </p>
        <p>
          <span>
            {{ $t('videoHistory.widgetDownload.downloadTime') }}
            {{ momentDMYH(downloadOn) }}
          </span>
        </p>
      </div>
    </div>
    <!-- TODO: Uncomment when ready -->
    <!-- <McProgressBar
      v-if="hasAccess(['b3q-trackvision-convert-video-download:read'])"
      :value="progress"
      labelPosition="inside"
    /> -->
    <b-progress :value="100" variant="secondary" :animated="true" class="mt-3" />
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
// import McProgressBar from '@/components/McProgressBar'
import { mapGetters } from 'vuex'

export default {
  name: 'VideoInProgress',
  components: {
    // McProgressBar,
  },
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    convertedChannel: {
      type: [String, Number],
      required: true,
    },
    deviceTimezone: {
      type: [String, Number],
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
    downloadOn: {
      type: String,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
    }),
  },
}
</script>
